import { render } from "./articleReviewed.vue?vue&type=template&id=632dba7b"
import script from "./articleReviewed.vue?vue&type=script&lang=js"
export * from "./articleReviewed.vue?vue&type=script&lang=js"

import "./articleReviewed.vue?vue&type=style&index=0&id=632dba7b&lang=scss"

import exportComponent from "F:\\webStorm workspace\\ujk_tangying\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__